import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "video-placeholder" }
const _hoisted_2 = {
  key: 1,
  class: "video-load-error-content"
}
const _hoisted_3 = { class: "video-load-error-links" }
const _hoisted_4 = {
  href: "https://support.google.com/chrome/answer/2693767",
  target: "_blank"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Chrome ")
const _hoisted_6 = {
  href: "https://support.microsoft.com/en-us/windows/camera-doesn-t-work-in-windows-10-32adb016-b29c-a928-0073-53d31da0dad5",
  target: "_blank"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Edge ")
const _hoisted_8 = {
  href: "https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Firefox ")

import { PropType } from 'vue';


export default _defineComponent({
  expose: [],
  props: {
  videoLoadError: Object as PropType<{ title: string; description: string } | null>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!__props.videoLoadError)
      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          icon: ['fas', 'video'],
          class: "video-icon"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'video-slash'],
            class: "video-slash"
          }),
          _createVNode("span", null, _toDisplayString(__props.videoLoadError.title), 1),
          _createVNode("span", null, _toDisplayString(__props.videoLoadError.description), 1),
          _createVNode("div", _hoisted_3, [
            _createVNode("a", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'external-link-alt'] })
            ]),
            _createVNode("a", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'external-link-alt'] })
            ]),
            _createVNode("a", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'external-link-alt'] })
            ])
          ])
        ]))
  ]))
}
}

})